import Story from "@/components/Story";

export default function StoryPage() {
  return (
    <div className="pt-16">
      <Story />
    </div>
  );
}
